<section class="auth-callback-page">
  <div class="auth-callback-card">
    @if (!error) {
      <kendo-loader size="small"></kendo-loader>
      <h2>Signing you in...</h2>
      <p>Please wait while we complete your session.</p>
    } @else {
      <h2>Sign-in could not be completed</h2>
      <p class="error">{{ error }}</p>
      <div class="actions">
        <button
          kendoButton
          type="button"
          themeColor="primary"
          (click)="goToLogin()"
        >
          Go to sign in
        </button>
      </div>
    }
  </div>
</section>
